import {
    LiteTradeSelectAccountItemBalanceStyled,
    LiteTradeSelectAccountItemStyled
} from "./styled/LiteTradeSelectAccountStyled";
import { BinIcon } from "../../../../components/icon/Icon";
import { ACCOUNT_TYPES } from "../../../../app/appConstants";
import amountFormat from "../../../../utils/amountFormat";
import { Button } from "react-bootstrap";
import { Slider, useSliderContext } from "../../../../components/Slider/Slider";
import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAppUser, getUserSelectedAccountCode } from "../../../../app/appSelectors";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import { getLiteTradeAllAccountsMetrics } from "../../liteTradeSelectors";
import { openMobileSliderPageAction } from "../../../../mobileAppCore/mobileAppActions";
import {
    MOBILE_SLIDER_PAGES_IDS
} from "../../../../mobileAppCore/components/MobileSliderPages/mobileSliderPagesConstants";

function LiteTradeSelectAccountRow(props) {
    const {account, handleAccountSelect, metricParam} = props;
    const {getLangPath} = useLangContext();
    const {closeSlider} = useSliderContext();

    const dispatch = useDispatch();
    const selectedAccountCode = useSelector(getUserSelectedAccountCode);
    const metrics = useSelector(getLiteTradeAllAccountsMetrics);
    const user = useSelector(getAppUser);

    const handleTopUpButtonClick = useCallback((e) => {
        e.stopPropagation();
        closeSlider();
        dispatch(openMobileSliderPageAction(MOBILE_SLIDER_PAGES_IDS.DEPOSIT));
    }, [closeSlider, dispatch]);

    return <Slider.Row data-value={account.name} onClick={handleAccountSelect}>
        <LiteTradeSelectAccountItemStyled
            selected={account.name === selectedAccountCode}
        >
            <span>
                <BinIcon
                    className={'account-type-icon'}
                    name={account.type === ACCOUNT_TYPES.DEMO ? 'IcEducation' : 'IcCoinStack'}
                    size={'24px'}/>
                <span>{getLangPath(`lite_version.home.${account.type === ACCOUNT_TYPES.DEMO ? 'demo' : 'real'}`)}</span>
            </span>
            <div className={'d-flex align-items-center'}>
                <LiteTradeSelectAccountItemBalanceStyled>
                    {metrics[account.name] ? amountFormat(metrics[account.name][metricParam], 2, '$') : ''}
                </LiteTradeSelectAccountItemBalanceStyled>
                {
                    !user?.buyer && account.type === ACCOUNT_TYPES.LIVE &&
                    <Button className={'top-up-button'} variant={'info'} onClick={handleTopUpButtonClick}>
                        <BinIcon name={'IcPlus'}/>
                        <span className={'ms-2'}>{getLangPath('lite_version.home.top_up')}</span>
                    </Button>
                }
            </div>
        </LiteTradeSelectAccountItemStyled>
    </Slider.Row>
}

export default LiteTradeSelectAccountRow;
